// 打包环境
// npm run build -- test 测试
// npm run build -- reprod 演示
// npm run build -- prod 正式


let HOST = process.env.HOST,
  baseUrl = '',
  baseUrlUpsis = '',
  ssoBaseUrl = '',
  baseUrlDotmgr = ''

if (HOST === 'test') {
  baseUrl = 'https://testsmartpen.ys100edu.com';
  baseUrlUpsis = 'https://testportal.ys100edu.com';
  ssoBaseUrl = 'https://testpassport.ys100edu.com/sso';
  baseUrlDotmgr = 'https://testdot.ys100edu.com';
  // baseUrl = 'http://127.0.0.1:8088';
  // baseUrlUpsis = 'http://172.20.20.41:97';
  // ssoBaseUrl = 'http://172.20.20.41:89/sso';
  // baseUrlDotmgr = 'http://127.0.0.1:9091';
}

if (HOST === 'reprod') {
  baseUrl = 'https://devsmartpen.ys100edu.com';
  baseUrlUpsis = 'https://devportal.ys100edu.com';
  ssoBaseUrl = 'https://devpassport.ys100edu.com/sso';
  baseUrlDotmgr = 'https://devdot.ys100edu.com';
}

if (HOST === 'prod') {
  baseUrl = 'https://smartpen.ys100edu.com';
  baseUrlUpsis = 'https://www.ys100edu.com/';
  ssoBaseUrl = 'https://passport.ys100edu.com/sso';
  baseUrlDotmgr = 'https://dot.ys100edu.com';
}


export default {
  baseUrl,
  baseUrlUpsis,
  ssoBaseUrl,
  baseUrlDotmgr
};



// WEBPACK FOOTER //
// ./src/utils/host.js